export default {
  create_warehouse_btn: 'إنشاء مستودع',
  filter: {
    search: {
      placeholder: 'تصفية قائمة المستودعات'
    },
    country: {
      all_option: 'كل البلدان'
    },
    status: {
      all_option: 'جميع الحالات'
    },
    sort: {
      new_to_old: ' من الجديد إلى القديم',
      old_to_new: 'من القديم إلى الجديد'
    }
  },
  table_card: {
    set_selected_status_to: 'عيِّن حالة {count} مستودعات الى:',
    buttons: {
      apply: 'تطبيق'
    },
    table: {
      creation_date: 'تاريخ الإنشاء',
      warehouse: 'المستودع',
      contact_name: 'اسم جهة الاتصال',
      Contact_details: 'بيانات الاتصال',
      countries: {
        title: 'البلدان',
        others: '{nb} أخرى'
      },
      last_month_confirmed_sales: 'آخر 30 يومًا مبيعات مؤكدة',
      status: 'الحالة',
      actions: 'الاجراءات'
    }
  },
  form: {
    toggle_form: 'انقر هنا لإنشاء مستودع.',
    warehouse_form: {
      create_warehouse: {
        title: 'إنشاء المستودع',
        subtitle: 'إنشاء مستودع جديد لمنتجاتك'
      },
      update_warehouse: {
        title: 'تعديل المستودع',
        subtitle: 'تعديل المستودع'
      },
      buttons: {
        create: 'انشاء المستودع',
        duplicate: 'نسخ المستودع',
        save: 'حفظ المستودع',
        cancel: 'الغاء'
      },
      fields: {
        owner: {
          title: 'المالك'
        },
        name: {
          title: 'اسم المستودع',
          placeholder: 'اكتب اسم المستودع'
        },
        user_name: {
          title: 'اسم المستخدم',
          placeholder: 'اكتب اسم مستخدم'
        },
        contact_name: {
          title: 'اسم جهة الاتصال',
          placeholder: 'اكتب اسم جهة اتصال'
        },
        email: {
          title: 'البريد الالكتروني',
          placeholder: 'example@example.com'
        },
        password: {
          title: 'كلمه المرور',
          placeholder: 'أكتب كلمة المرور'
        },
        confirmation: {
          title: 'تأكيد كلمة المرور',
          placeholder: 'كرر كلمة المرور'
        },
        phone: {
          title: 'الهاتف',
          placeholder: 'أكتب رقم الهاتف'
        },
        skype: {
          title: 'هوية السكايب',
          placeholder: 'اكتب معرف سكايب'
        },
        countries: {
          title: 'دول المستودعات',
          hint: 'ما هي المناطق المستهدفة؟'
        },
        country: {
          title: 'دول المستودعات',
          sub_title: 'حدد دول مخزون المستودعات، ويمكنك اختيارياً ضبط تكاليف التجهيز والشحن حسب الدولة.',
          add_button: 'أضف دولة'
        },
        activate_call_center: {
          title: 'تفعيل مركز الاتصال'
        }
      },
      define_warehouse_costs: 'حدد تكاليف المستودع بالدولار الأمريكي حسب البلد لـلانجاز ، وتكاليف البيع والشحن',
      country_cost_table: {
        country: 'الدولة',
        fulfillment: 'الانجاز',
        upsell: 'Upsell',
        shipping: 'الشحن',
        returns: 'الارجاع',
        tax: 'ضريبة %',
        other: 'أخرى %',
        actions: 'الاجراءات'
      }
    },
    call_agent_form: {
      create_call_agent: {
        title: 'إنشاء وكيل اتصال',
        subtitle: 'قم بإنشاء وكيل الاتصال الرئيسي لهذا المستودع'
      },
      update_call_agent: {
        title: 'تعديل وكيل اتصال',
        subtitle: 'تعديل وكيل اتصال'
      }
    }
  }
};